import { useEffect, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { getPendingCount } from '../../api'

export default function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [pendingCount, setPendingCount] = useState(0)
  const [navOpen, setNavOpen] = useState(false)

  const isSuperAdmin = user?.role === 'SUPER_ADMIN'
  const isAdmin = user?.role === 'ADMIN' || isSuperAdmin

  useEffect(() => {
    if (isAdmin) {
      getPendingCount().then((r: any) => setPendingCount(r.data.count)).catch(() => {})
      const interval = setInterval(() => {
        getPendingCount().then((r: any) => setPendingCount(r.data.count)).catch(() => {})
      }, 30000)
      return () => clearInterval(interval)
    }
  }, [isAdmin])

  const navLink = (to: string, label: string, badge?: number) => (
    <Link to={to} className={`nav-link ${pathname.startsWith(to) ? 'active' : ''}`} onClick={() => setNavOpen(false)}>
      {label}
      {badge ? (
        <span style={{ marginLeft: 6, background: '#ef4444', color: '#fff', borderRadius: 10, padding: '1px 6px', fontSize: 10, fontWeight: 700 }}>
          {badge}
        </span>
      ) : null}
    </Link>
  )

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <nav className="layout-nav">
        <button className="nav-toggle" onClick={() => setNavOpen(o => !o)}>☰</button>
        <span className="nav-brand">RASCOTEC</span>

        <div className={`nav-links ${navOpen ? 'open' : ''}`}>
          {isSuperAdmin && navLink('/dashboard', 'Dashboard')}
          {navLink('/invoices', 'Invoices')}
          {navLink('/customers', 'Customers')}
          {isAdmin && navLink('/products', 'Products')}
          {isAdmin && navLink('/edit-requests', 'Edit Requests', pendingCount > 0 ? pendingCount : undefined)}
          {isSuperAdmin && navLink('/reports', 'Reports')}
          {isSuperAdmin && navLink('/users', 'Users')}
        </div>

        <div className="nav-spacer" />
        <span className="nav-user">
          {user?.full_name} <span>({user?.role})</span>
        </span>
        <button className="nav-logout" onClick={() => { logout(); navigate('/login') }}>Logout</button>
      </nav>
      <main style={{ flex: 1 }}>{children}</main>
    </div>
  )
}
